import Vuex from 'vuex';
import Vue from 'vue';

import categoriesModule from './modules/categoriesModule';
import collectionsModule from './modules/collectionsModule';
import colorsModule from './modules/colorsModule';
import productsModule from './modules/productsModule';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    categories: categoriesModule,
    collections: collectionsModule,
    colors: colorsModule,
    products: productsModule,
  },
  state: {
    user: null,
    notificationsId: 0,
    notifications: [],
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    addNotification(state, notification) {
      const notificationWithId = {
        ...notification,
        id: notification.id || state.notificationsId++,
      };
      state.notifications = [
        ...state.notifications.filter(n => notification.id !== n.id),
        notificationWithId,
      ];
      return notificationWithId.id;
    },
    removeNotification(state, { id }) {
      state.notifications = state.notifications.filter(notification => notification.id !== id);
    },
  },
  actions: {
    setUser({commit}, user) {
      return commit('setUser', user);
    },
    unsetUser({commit}) {
      return commit('setUser', null);
    },

    addNotification({commit}, notification) {
      return commit('addNotification', notification);
    },
    addNotificationError({commit}, text) {
      console.error(text);
      return commit('addNotification', {
        text,
        type: 'warning',
        className: 'bg-warning',
      });
    },
    addNotificationSuccess({commit}, text) {
      return commit('addNotification', {
        text,
        type: 'success',
      });
    },
    removeNotification({commit}, notification) {
      return commit('removeNotification', notification);
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js